import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=bb66f4a0&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=bb66f4a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb66f4a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb66f4a0')) {
      api.createRecord('bb66f4a0', component.options)
    } else {
      api.reload('bb66f4a0', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=bb66f4a0&scoped=true&", function () {
      api.rerender('bb66f4a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2AoMijUV698hS/JS/comp/PopupDialog.vue"
export default component.exports